var map = {
	"./10000032": [
		6248,
		248
	],
	"./10000032.json": [
		6248,
		248
	],
	"./10000084": [
		83437,
		437
	],
	"./10000084.json": [
		83437,
		437
	],
	"./10000117": [
		19646,
		646
	],
	"./10000117.json": [
		19646,
		646
	],
	"./data": [
		36884
	],
	"./data.json": [
		36884
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40765;
module.exports = webpackAsyncContext;